export const CountPaginationOffset = (page, rowsPerPage) => {
    return (page - 1) * rowsPerPage
}